import axios from 'axios';
import authHeader from './auth-header';
import BasicService from './basic.service'

class FriendsService extends BasicService {
    getFriends(dbid) {
        return this.checkError(axios.get(this.API_URL + 'friends/client/' + dbid, { headers: authHeader() }));
    }

    send(dbid) {
        return this.checkError(axios.post(this.API_URL + 'friends/client/' + dbid, {}, { headers: authHeader() }));
    }

    accept(id) {
        return this.checkError(axios.post(this.API_URL + 'friends/' + id, {}, { headers: authHeader() }));
    }

    delete(id) {
        return this.checkError(axios.delete(this.API_URL + 'friends/' + id,  { headers: authHeader() }));
    }
}

export default new FriendsService();